// Résolution d'un jeton scanné (26/09/2026, campagne adversariale Recette).
//
// 1. L'id est validé AVANT tout appel Firestore : un QR étranger contient
//    souvent une URL (« https://… », donc « / »), que `doc()` refuse en
//    levant une exception (« Invalid segment ») : l'écran tournait sans fin.
//    On ne suppose pas le format des jetons imprimés (16 caractères
//    aujourd'hui) : seulement ce que Firestore et les règles refusent.
// 2. « N'existe pas » ne vaut que si le SERVEUR le dit. Hors ligne, sur un
//    profil neuf, le 1er instantané vient du cache local (vide) : un jeton
//    valide s'affichait « introuvable » pour de bon, et comptait comme
//    tentative invalide pour l'anti-brute-force.

export const ID_MAX = 64; // cf. texteCourt(tid, 64) dans firestore.rules

export function idJetonValide(id) {
  if (typeof id !== "string") return false;
  if (id.length === 0 || id.length > ID_MAX) return false;
  if (id.includes("/")) return false;
  if (id === "." || id === "..") return false;
  if (/^__.*__$/.test(id)) return false;
  return true;
}

/** Statut du jeton d'après un instantané : "found" | "not-found" | "offline". */
export function statutDuJeton({ existe, fromCache }) {
  if (existe) return "found";
  return fromCache ? "offline" : "not-found";
}

// Identifiant d'un jeton depuis l'URL d'arrivée /tk/... (QR imprimé). Le
// navigateur range un « # » ou un « ? » de l'id dans hash/search : on recolle
// pathname + search + hash (cf. router.js). A10 : un « % » mal formé ne lève
// plus d'URIError (id gardé brut, l'écran dira « pas un jeton ») ; /tk/ vide
// rend "" (le routeur renvoie alors à l'accueil). A12 : même chose derrière le
// préfixe /nav (retour du navigateur intégré, id ré-encodé en un segment).
export function idDepuisChemin(pathname, search = "", hash = "") {
  const brut = (pathname + search + hash).replace(/^(?:\/nav)?\/tk\/?/, "");
  try {
    return decodeURIComponent(brut);
  } catch {
    return brut;
  }
}
